import type { ComboboxOptionType } from '@zillow/constellation-10';
import { FormField, Label, Layout, Paragraph } from '@zillow/constellation-10';
import { TimeZoneDropdownSelect } from '@zg-rentals/touring';
import type { TimeZoneIds } from '@zg-rentals/touring';
import { WizardBody, WizardFormSectionContainer, WizardHeading } from '../../../../styles/wizard';

type TourSchedulingTimeZoneBodyProps = {
  selectedTimeZone?: TimeZoneIds;
  onSelectTimeZone: (option: ComboboxOptionType) => void;
};

const TourSchedulingTimeZoneBody = ({ selectedTimeZone, onSelectTimeZone }: TourSchedulingTimeZoneBodyProps) => {
  return (
    <div data-testid="TourSchedulingTimeZoneBody">
      <WizardFormSectionContainer>
        <WizardHeading level={1} textStyle="heading-sm" data-testid="TourSchedulingTimeZoneBody-Heading">
          Select the property time zone
        </WizardHeading>
        <WizardBody>
          <Layout.Root>
            <Layout.Content css={{ gridColumnEnd: { base: 'span 12', md: 'span 8' }, padding: 'zero' }}>
              <Paragraph data-testid="TourSchedulingTimeZoneBody-Description">
                This helps ensure that your tour availability matches what&apos;s provided to interested renters.
              </Paragraph>
            </Layout.Content>
            <Layout.Content css={{ gridColumnEnd: { base: 'span 0', md: 'span 4' }, padding: 'zero' }}></Layout.Content>
          </Layout.Root>
        </WizardBody>

        <Layout.Root>
          <Layout.Content css={{ gridColumnEnd: { base: 'span 12', md: 'span 8' }, padding: 'zero' }}>
            <FormField
              label={<Label size="lg">Property time zone</Label>}
              control={
                <TimeZoneDropdownSelect
                  timeZone={selectedTimeZone}
                  handleOptionSelect={onSelectTimeZone}
                  disableTimeZoneSelection={false}
                />
              }
              required={true}
              css={{ marginBottom: 'tight' }}
            />
          </Layout.Content>
          <Layout.Content css={{ gridColumnEnd: { base: 'span 0', md: 'span 4' }, padding: 'zero' }}></Layout.Content>
        </Layout.Root>
      </WizardFormSectionContainer>
    </div>
  );
};

export default TourSchedulingTimeZoneBody;
